const levels = {
  '1': {
    cratesAllowed: 3,
    totalBalls: 1,
    ballSpeed: 80,
  },
  '2': {
    cratesAllowed: 4,
    totalBalls: 2,
    ballSpeed: 70,
  },
  '3': {
    cratesAllowed: 5,
    totalBalls: 3,
    ballSpeed: 60,
  },
};

export default levels;



// WEBPACK FOOTER //
// ./src/data/levels.js